/**
 * Catálogo de códigos de modificación DGII para frontend
 * Según especificación e-CF 33/34 v.1.0
 * 
 * ⚠️ SINCRONIZAR CON:
 * - Backend: core/servidor/controladores/util/codigos_modificacion.js
 * - ecfService: ecfService/src/controladores/util/mapeos_dgii.js
 * - Base de datos: tabla codigo_modificacion_dgii
 * 
 * @module codigosModificacionDGII
 */

/**
 * @constant {Object} CODIGOS_MODIFICACION_DGII
 */
export const CODIGOS_MODIFICACION_DGII = {
  1: { 
    descripcion: 'Anula el NCF modificado', 
    corta: 'Anulación',
    color: 'red'
  },
  2: { 
    descripcion: 'Corrige texto del comprobante', 
    corta: 'Corrección texto',
    color: 'blue'
  },
  3: { 
    descripcion: 'Corrige montos del NCF', 
    corta: 'Corrección montos',
    color: 'yellow'
  },
  4: { 
    descripcion: 'Reemplazo NCF contingencia', 
    corta: 'Contingencia',
    color: 'purple'
  },
  5: { 
    descripcion: 'Ref. Factura Consumo', 
    corta: 'Ref. consumo',
    color: 'green'
  }
};

/**
 * Obtener descripción legible de código de modificación
 * @param {number|string} codigo - Código de modificación (1-5)
 * @param {boolean} [corta=false] - Si true, retorna versión abreviada
 * @returns {string} Descripción del código
 * 
 * @example
 * obtenerDescripcionCodigoModificacion(1) // "Anula el NCF modificado"
 * obtenerDescripcionCodigoModificacion(1, true) // "Anulación"
 */
export function obtenerDescripcionCodigoModificacion(codigo, corta = false) {
  const cod = CODIGOS_MODIFICACION_DGII[codigo];
  if (!cod) return 'No especificado';
  return corta ? cod.corta : cod.descripcion;
}

/**
 * Obtener clases Tailwind para badge según código
 * @param {number|string} codigo
 * @returns {Object} {texto, colorClasses}
 * 
 * @example
 * const badge = obtenerBadgeCodigoModificacion(1);
 * // { texto: "Anulación", colorClasses: "bg-red-100 text-red-800" }
 */
export function obtenerBadgeCodigoModificacion(codigo) {
  const cod = CODIGOS_MODIFICACION_DGII[codigo];
  
  if (!cod) {
    return {
      texto: 'No especificado',
      colorClasses: 'bg-gray-100 text-gray-600'
    };
  }
  
  const colorMap = {
    red: 'bg-red-100 text-red-800',
    blue: 'bg-blue-100 text-blue-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    purple: 'bg-purple-100 text-purple-800',
    green: 'bg-green-100 text-green-800'
  };
  
  return {
    texto: cod.corta,
    colorClasses: colorMap[cod.color] || 'bg-gray-100 text-gray-800'
  };
}

